import { useState } from 'react';
import { ApolloError } from '@apollo/client/errors';
import {
  getApolloClient,
  ORGANISATION_SERVICE_ENDPOINT,
} from '../../apollo/getApolloClient';
import { GET_ORGANISATION_NAME } from '../../apollo/queries';

export interface OrganisationsByName {
  name: string;
}

type getOrgFunction = (codes: string[]) => Promise<void>;

interface QueryResult {
  organisations: OrganisationsByName[];
  isLoading: boolean;
  error: ApolloError | null;
}

type OrganisationNameMutationResponse = [getOrgFunction, QueryResult];

const useOrganisationsNameMutation = (): OrganisationNameMutationResponse => {
  const client = getApolloClient(ORGANISATION_SERVICE_ENDPOINT);

  const [organisations, setOrganisations] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getOrganisationsNames = async (codes: string[]): Promise<void> => {
    setIsLoading(true);

    try {
      const { data } = await client.query({
        query: GET_ORGANISATION_NAME,
        variables: { codes },
      });

      setOrganisations(data.organisationsByCodes);
    } catch (e: any) {
      setError(e);
    }

    setIsLoading(false);
  };

  return [getOrganisationsNames, { organisations, isLoading, error }];
};

export default useOrganisationsNameMutation;
